export default __webpack_public_path__ + "static/media/s_wdt_c_2.37589c29.mp3";